@use "../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../styles/Colors.scss" as Colors;

.additional-filters {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: Constants.$val-spacing-s;
	padding-top: Constants.$val-spacing-s;
	flex-wrap: wrap;

	&__reset-button {
		color: Colors.$col-darkBlueBorder;
		cursor: pointer;
	}
}

.job-option {
	display: flex;
	flex-direction: column;

	&__label {
		font-weight: bold;
	}

	&__subtitle {
		font-size: Constants.$val-fontSizeSmall;
		color: Colors.$col-greyFontLight;
		display: flex;
		align-items: center;
	}

	&__internal-indicator {
		background: Colors.$col-black;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 14px;
		width: 14px;
		font-size: 8px;
		line-height: 8px;
		color: Colors.$col-white;
		font-weight: bold;
		border-radius: Constants.$val-borderRadius;
		margin-right: Constants.$val-spacing-xs;
	}
}

.job-option-subtitle {
	font-size: Constants.$val-fontSizeSmall;
	color: Colors.$col-greyFontLight;
	display: flex;
	align-items: center;
}

.internal-indicator {
	background: Colors.$col-black;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 14px;
	width: 14px;
	font-size: 8px;
	line-height: 8px;
	color: Colors.$col-white;
	font-weight: bold;
	border-radius: Constants.$val-borderRadius;
	margin-right: Constants.$val-spacing-xs;
}
